import moment from 'moment'
import Vue from 'vue'
import Config from '@/config'
import { AppState } from '@/state'

const Utils = {
  buildURL (base, params) {
    const q = Object.keys(params).map(key => [key, params[key]].map(encodeURIComponent).join('=')).join('&')
    return `${base}?${q}`
  },

  relativeShortDate (forDate) {
    let dateFormatStr = 'MMM DD'
    const now = moment(new Date())
    const forDateM = Utils.getMomentDate(forDate)
    const diffDays = forDateM.diff(now, 'days')

    if (now.year() !== forDateM.year()) {
      dateFormatStr = 'MMM DD, YYYY'
    }

    if (Math.abs(diffDays) < (3 * 7)) {
      dateFormatStr = 'ddd, MMM DD'
      const diffNumber = forDateM.date() - now.date()

      if (diffNumber === 0) {
        return 'Today'
      } else if (diffNumber === -1) {
        return 'Yesterday'
      } else if (diffNumber === 1) {
        return 'Tomorrow'
      }
    }

    return forDateM.format(dateFormatStr)
  },

  shortDate (forDate) {
    const today = moment(new Date())
    let format = 'MMM DD'
    if (forDate.year() !== today.year()) {
      format = 'MMM DD, YYYY'
    }

    return forDate.format(format)
  },

  simpleDateString (forDate) {
    return Utils.getMomentDate(forDate).format('MMM DD, YYYY')
  },

  simpleDateTimeString (forDate) {
    return Utils.getMomentDate(forDate).format('DD MMM YYYY, h:mm a')
  },

  relativeTime (forDate) {
    const mdate = Utils.getMomentDate(forDate)
    let timeString = mdate.format('hh:mm a')
    if (mdate.hours() === 0 && mdate.minutes() === 0) {
      timeString = 'midnight'
    }
    return timeString
  },

  relativeShortDateTime (forDate) {
    const dateString = Utils.relativeShortDate(forDate)
    const timeString = Utils.relativeTime(forDate)

    return `${dateString} ${timeString}`
  },

  getMomentDate (forDate) {
    if (moment.isMoment(forDate)) {
      return forDate
    }

    if (!isNaN(forDate)) {
      forDate = moment.unix(forDate)
    } else if (typeof (forDate) === 'string') {
      forDate = moment(forDate)
    }

    return forDate
  },

  momentFormat (forDate, format) {
    return Utils.getMomentDate(forDate).format(format)
  },

  buildStatusClass (status, inProgress) {
    if (inProgress === true) {
      return {
        in_progress: true,
        completed: false,
        partial_completed: false,
        active: false
      }
    }

    return {
      in_progress: false,
      completed: (status === 'completed'),
      partial_completed: (status === 'partial_completed'),
      active: (status !== 'completed' && status !== 'partial_completed')
    }
  },

  capitalise (key, defaultValue) {
    if (key === undefined || key === null) { return defaultValue || '-' }
    if (key.length === 0) { return defaultValue || '' }

    return key.split(/[_\-.]/).map((word) => {
      return word.replace(word[0], word[0].toUpperCase())
    }).join(' ')
  },

  capitaliseUpper (key) {
    return key.split(/[_\-.]/).map((word) => {
      return word.toUpperCase()
    }).join(' ')
  },

  uniqueId () {
    return '_' + Math.random().toString(36).substr(2, 9)
  },

  diffInCalendarDate (fromDate, toDate) {
    const x = fromDate.clone().set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
    const y = toDate.clone().set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
    return x.diff(y, 'days')
  },

  join (listOfItem) {
    return listOfItem.join(', ')
  },

  locale (val, defaultValue) {
    if (val === null || val === undefined) {
      if (defaultValue === undefined) {
        return 'NULL'
      }
      return defaultValue
    }

    return val.toLocaleString()
  },

  mergeArray (dest, toMerge) {
    const len = Math.min(dest.length, toMerge.length)
    for (let i = 0; i < len; i++) {
      dest.splice(i, 1, toMerge[i])
    }

    if (toMerge.length > dest.length) {
      const toAdd = toMerge.slice(dest.length)
      dest.push(...toAdd)
    }
  },

  price (amount, currency) {
    let newAmount = amount
    const converstion = AppState.instance.currencyConv
    const rounded = AppState.instance.roundedFigure
    if (converstion.selected.enable && converstion.selected.from === currency) {
      newAmount = converstion.selected.amount * newAmount
      currency = converstion.selected.to
    }

    let style = 'currency'
    let converted = parseFloat(newAmount, 10)
    if (rounded) {
      converted = Math.round(converted)
      style = undefined
    }

    return converted.toLocaleString(
      undefined,
      { style, currency, currencySign: 'accounting' })
  }
}

Vue.filter('shortDate', Utils.shortDate)
Vue.filter('simpleDate', Utils.simpleDateString)
Vue.filter('simpleDateTimeString', Utils.simpleDateTimeString)
Vue.filter('relativeShortDate', Utils.relativeShortDate)
Vue.filter('relativeShortDateTime', Utils.relativeShortDateTime)
Vue.filter('relativeTime', Utils.relativeTime)
Vue.filter('momentFormat', Utils.momentFormat)
Vue.filter('capitalise', Utils.capitalise)
Vue.filter('capitaliseUpper', Utils.capitaliseUpper)
Vue.filter('join', Utils.join)
Vue.filter('locale', Utils.locale)
Vue.filter('price', Utils.price)

export default Utils
